import { appState } from "./AppState";

/**
 * Handles the contents of the enhanced server config endpoint response.
 */
export module EnhancedConfigResponseHandler {

    const ConfigurablePublishBatchSizeFeatureName: string = "ConfigurablePublishBatchSize";

    /**
     * Contains all of the logic required to run in response to the enhanced
     * server config being retrieved.
     * NOTE: appState.State.ServerConfig should not be undefined prior to
     * calling this method.
     * @param options The enhanced server config.
     */
    export function handleResponse(options) {
        // Check if the workbook server config features array has been initialized. If not, set it to an empty array.
        if (!appState.State.ServerConfig?.Features) {
            appState.State.ServerConfig.Features = [];
        }

        const elements = options?.Data?.parmElements;

        // If the enhanced server config has been retrieved successfully, go through its contents and update the application state accordingly.
        if (elements) {
            configurablePublishBatchSizeFeatureHandler(elements.isConfigurablePublishBatchSizeEnabled, elements.PublishBatchLimit);
        }
    }

    /**
     * Handles the enhanced server config elements relating to the configurable
     * publish batch size feature and updates the application state accordingly.
     * @param isConfigurablePublishBatchSizeEnabled True if the configurable publish batch size feature is enabled. False otherwise.
     * @param adminConfigPublishBatchLimit Admin-set publish batch size found on the OfficeAppParametersPage form.
     */
    function configurablePublishBatchSizeFeatureHandler(isConfigurablePublishBatchSizeEnabled: boolean, adminConfigPublishBatchLimit: number) {
        if (isConfigurablePublishBatchSizeEnabled === true && appState.State.ServerConfig.Features.indexOf(ConfigurablePublishBatchSizeFeatureName) < 0) {
            appState.State.ServerConfig.Features.push(ConfigurablePublishBatchSizeFeatureName);

            const DataPublishBatchLimitDefaultAndMax: number = 100;

            // Sanitize the application environment publish batch limit passed in through the public
            // server config endpoint.
            var environmentConfigPublishBatchLimit: number = appState.State.ServerConfig.DataPublishBatchLimit;
            if (!environmentConfigPublishBatchLimit || environmentConfigPublishBatchLimit > DataPublishBatchLimitDefaultAndMax) {
                environmentConfigPublishBatchLimit = DataPublishBatchLimitDefaultAndMax;
            }

            // Sanitize the admin-set publish batch limit passed in through the authenticated
            // enhanced server config endpoint.
            if (!adminConfigPublishBatchLimit || adminConfigPublishBatchLimit > DataPublishBatchLimitDefaultAndMax) {
                adminConfigPublishBatchLimit = DataPublishBatchLimitDefaultAndMax;
            }

            // Set the workbook's maximum publish batch limit. If the application environment publish batch
            // limit is less than the admin-set limit, set it as the maximum. Otherwise, set the admin-set
            // publish batch limit as the maximum.
            appState.State.ServerConfig.DataPublishBatchLimit = environmentConfigPublishBatchLimit < adminConfigPublishBatchLimit ? environmentConfigPublishBatchLimit : adminConfigPublishBatchLimit;
        }
    }
}